export default {
    ORDER_STATE_REJECTED: 'Rejected',
    ORDER_STATE_ACTIVE: 'Active',
    ORDER_STATE_TERMINATE: 'Terminate',
    ORDER_STATE_TERMINATING: 'Terminating',
    ORDER_STATE_ACTIVATE: 'Activate',
    ORDER_STATE_ACTIVATING: 'Activating',
    ORDER_STATE_UPDATE: 'Update',
    ORDER_STATE_UPDATING: 'Updating',
}